import { WindowScrollService } from "src/app/shared/services/window-scroll.service";
import { InvestorCapabilitiesService } from "src/app/shared/services/investor-capabilities.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.states";
import {
  financialTransactions,
  savingSuccessStateById,
} from "../../../state/financial-transactions.selectors";
import { Observable, Subject } from "rxjs";
import { OverlayService } from "src/app/shared/modules/overlay/services/overlay.service";
import { DisplayFileComponent } from "src/app/shared/UI/organisms/display-file/display-file.component";
import { FinancialTransactionActions } from "../../../state/financial-transactions.action-types";
import { FinancialTransactionItemComponent } from "../../organisms/financial-transaction-item/financial-transaction-item.component";
import { takeUntil } from "rxjs/operators";
import { UsersSelectors } from "src/app/features/users/state/users.selector-types";
import { FormGroup, FormBuilder } from "@angular/forms";
import { FinancialTransactionType } from "src/app/shared/enums/FinancialTransactionType.enum";
import { FinancialTransactionStatus } from "src/app/shared/enums/FinancialTransactionStatus.enum";
import { Roles } from "src/app/shared/enums/Roles.enum";
import {
  ActivatedRoute,
  Router,
} from "@angular/router";
import { createDateOnly } from "src/app/shared/util/date.util";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
} from "@angular/material-moment-adapter";
import { FinancialtransactionsService } from "../../../services/financial-transactions.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Toaster } from "ngx-toast-notifications";
import { showToast } from "src/app/shared/util/toaster.util";
import moment from "moment";
import FileSaver from "file-saver";
import b64toBlob from "b64-to-blob";
import { MatDialog } from "@angular/material/dialog";
import { MotiveDialogComponent } from "src/app/features/invoices/UI/organisms/motive-dialog/motive-dialog.component";
import { GTMService } from "src/app/shared/services/gtm.service";
import { ApproveDepositDialogComponent } from "src/app/features/invoices/UI/organisms/approve-deposit-dialog/approve-deposit-dialog.component";
import { EditInvestmentDialogComponent } from "src/app/features/invoices/UI/organisms/edit-investment-dialog/edit-investment-dialog.component";
import { FinancialTransactionUpdateItemComponent } from "../../organisms/financial-transaction-update-item/financial-transaction-update-item.component";

@Component({
  selector: "app-list-financial-transactions-template",
  templateUrl: "./list-financial-transactions-template.component.html",
  styleUrls: ["./list-financial-transactions-template.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class ListFinancialTransactionsTemplateComponent
  implements OnInit, OnDestroy {
  pageTitle = "Transacciones financieras";
  pageDescription =
    "Puedes depositar, retirar o revisar tus transacciones pendientes e históricas.";
  financialTransactioins$: Observable<any>;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  loggedInUserRole;
  transactions;
  filtersForm: FormGroup;
  typesList = Object.values(FinancialTransactionType);
  statusesList = Object.values(FinancialTransactionStatus);
  financialTransactioins;
  financialTransactioinsInvestor;
  selected = 0;
  pagination = {
    total: 0,
    limit: 10,
    skip: 0,
  };
  defaultPagination = {
    total: 0,
    limit: 10,
    skip: 0,
  };
  selectedInvestor;
  filterDefault = {
    types: [FinancialTransactionType.Deposit],
    statuses: [FinancialTransactionStatus["In Process"]],
    createdFrom: undefined,
    createdTo: undefined,
    currencies: undefined,
    amount: undefined,
    transactionId: undefined,
    investor: undefined,
    pagination: undefined,
  };
  currency = "pen";
  firtsLabel;
  secondLabel;
  default = true;
  toggle;
  displayToggle = true;
  deposit;
  withdraw;
  tabTransactions;
  investment;
  withdrawLength;
  depositLength;
  investmentLength;
  retentionLength;
  retention;
  dontTriggerTabEvent = false;
  showMotiveDialog = false;
  selectedEntity = new Object();
  rejectionReason = "";
  subscription;
  showApproveDialog = false;
  documentNumber = "";
  showEditInvestmentDialog = false;
  editedInvestmentData: any = null;
  profile;
  constructor(
    private store: Store<AppState>,
    private overlayService: OverlayService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private service: FinancialtransactionsService,
    private _adapter: DateAdapter<any>,
    private spinner: NgxSpinnerService,
    private windowScrollService: WindowScrollService,
    public dialog: MatDialog,
    private gmtService: GTMService,
    private investorCapabilities: InvestorCapabilitiesService,
    private toaster: Toaster
  ) { }

  /**
   * FIN-1709 · the two "Nuevo …" buttons on this page open the same screens the route
   * guard decides on, and asked nobody. An inversionista the guard refuses was still
   * offered both — the guard bounced them to `/opportunities` on the click, which reads
   * as the app losing their place rather than as a refusal.
   *
   * FIN-1711 · the case this was written against was FIN-1714's disapproved inversionista,
   * restricted to retiro and still offered *Nuevo depósito*. That standing is gone; the
   * buttons still ask, for the pre-approved window FIN-1709 owns.
   *
   * Disabled rather than removed, like the *Invertir* button: what is unavailable stays
   * visible, so the screen does not silently change shape per account state.
   */
  canDeposit(): boolean {
    return this.investorCapabilities.capabilitiesFor(this.profile).deposit;
  }

  canWithdraw(): boolean {
    return this.investorCapabilities.capabilitiesFor(this.profile).withdraw;
  }

  ngOnInit() {
    this.store
      .select(UsersSelectors.profileProperty("role"))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((loggedInRole) => {
        if (loggedInRole) {
          this.loggedInUserRole = loggedInRole;
        }
      });

    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((profile) => {
        this.profile = profile;
      });

    if (this.loggedInUserRole === Roles.ADMIN || this.loggedInUserRole === Roles.SUPER_ADMIN || this.loggedInUserRole === Roles.INVESTOR_SALES || this.loggedInUserRole === Roles.INVESTOR_SALES_SUPERVISOR) {
      this._adapter.setLocale("es-PE");

      this.filtersForm = this.fb.group({
        types: [this.filterDefault.types],
        statuses: [this.filterDefault.statuses],
        createdFrom: [this.filterDefault.createdFrom],
        createdTo: [this.filterDefault.createdTo],
        currencies: [this.filterDefault.currencies],
        amount: [this.filterDefault.amount],
        transactionId: [this.filterDefault.transactionId],
        investor: [this.filterDefault.investor],
        pagination: [this.filterDefault.pagination],
      });

      const previousFilters = JSON.parse(
        localStorage.getItem("transactions_filter")
      );
      if (previousFilters) {
        this.filtersForm.controls["types"].setValue(previousFilters.types);
        this.filtersForm.controls["statuses"].setValue(
          previousFilters.statuses
        );
        if (previousFilters.createdFrom)
          this.filtersForm.controls["createdFrom"].setValue(
            moment(previousFilters["createdFrom"])
          );
        if (previousFilters.createdTo)
          this.filtersForm.controls["createdTo"].setValue(
            moment(previousFilters["createdTo"])
          );
        this.filtersForm.controls["currencies"].setValue(
          previousFilters.currencies
        );
        this.filtersForm.controls["amount"].setValue(previousFilters.amount);
        this.filtersForm.controls["transactionId"].setValue(previousFilters.transactionId);
        this.filtersForm.controls["pagination"].setValue(
          previousFilters.pagination
        );
        this.filtersForm.controls["investor"].setValue(
          previousFilters.investor_id
        );

        this.pagination = {
          total: 0,
          limit: 10,
          skip: previousFilters.pagination,
        };
        this.selectedInvestor = previousFilters.investor;
      }
      this.applyFilter(true);
    } else {
      // this.financialTransactioins$ = this.store.select(financialTransactions);
      this.listTransactions();
    }
    this.subscription = this.overlayService
      .getCloseEmitter()
      .subscribe((obs) => {

        if (this.showMotiveDialog && this.selectedEntity) {
          this.rejected(this.selectedEntity);
        } else if (this.showApproveDialog && this.selectedEntity) {
          this.approved(this.selectedEntity);
        } else if (this.showEditInvestmentDialog && this.selectedEntity) {
          this.editInvestment(this.selectedEntity);
        }
      });
  }

  // sendEventSprig() {
  //   let event = {
  //     event: "[Platform][Create][Deposit]",
  //   };
  //   this.gmtService.newEvent(event);
  //   localStorage.removeItem("send_survey");
  // }
  setCurrency($event) {
    this.currency = $event;
    this.filterByCurrency();
    this.setLocalStorage();
    this.tabTransactions = 0;
    this.selected = 0;
    this.resetPagination();
    this.dontTriggerTabEvent = true;
    this.sendEventPageView(this.currency);
  }

  filterByCurrency() {
    this.financialTransactioins = this.transactions;
    if (this.financialTransactioins) {
      const transactionsByCurrencyDeposit = this.financialTransactioins.filter(
        (oppor) => oppor.currency === this.currency && oppor.type === "deposit"
      );

      const transactionsByCurrencyWithdraw = this.financialTransactioins.filter(
        (oppor) =>
          oppor.currency === this.currency &&
          (oppor.type === "withdraw" || oppor.type === "donate")
      );

      const transactionsByCurrencyRetention =
        this.financialTransactioins.filter(
          (oppor) =>
            oppor.currency === this.currency && oppor.type === "retention"
        );

      const transactionsByCurrencyInvestment =
        this.financialTransactioins.filter(
          (oppor) =>
            oppor.currency === this.currency &&
            (oppor.type === "investment" || oppor.type === "investment return")
        );
      this.deposit = transactionsByCurrencyDeposit;
      this.withdraw = transactionsByCurrencyWithdraw;
      this.investment = transactionsByCurrencyInvestment;
      this.retention = transactionsByCurrencyRetention;

      this.depositLength = transactionsByCurrencyDeposit;
      this.withdrawLength = transactionsByCurrencyWithdraw;
      this.investmentLength = transactionsByCurrencyInvestment;
      this.retentionLength = transactionsByCurrencyRetention;

      this.updatePagination();
    }
  }

  updatePagination() {
    if (this.selected === 0) {
      const deposit = this.deposit;
      this.pagination.total = deposit.length;
      this.deposit = deposit.slice(
        this.pagination.skip,
        this.pagination.limit + this.pagination.skip
      );
    } else if (this.selected === 1) {
      const withdraw = this.withdraw;
      this.pagination.total = withdraw.length;
      this.withdraw = withdraw.slice(
        this.pagination.skip,
        this.pagination.limit + this.pagination.skip
      );
    } else if (this.selected === 2) {
      const retention = this.retention;
      this.pagination.total = retention.length;
      this.retention = retention.slice(
        this.pagination.skip,
        this.pagination.limit + this.pagination.skip
      );
    } else if (this.selected === 3) {
      const investment = this.investment;
      this.pagination.total = investment.length;
      this.investment = investment.slice(
        this.pagination.skip,
        this.pagination.limit + this.pagination.skip
      );
    }
  }

  setLocalStorage() {
    localStorage.setItem("toggle_transaction_currency", this.currency);
    //localStorage.setItem('tab_transactions', this.selected.toString())
  }

  updateTabSelected($event) {
    // this.selected = 0
    // this.tabTransactions = 0
    this.resetPagination();
    this.selected = $event;
    //localStorage.setItem('tab_transactions', this.selected.toString())
    this.updatePagination();

    if (!this.dontTriggerTabEvent) {
      this.sendEventPageView(this.currency);
    } else {
      this.dontTriggerTabEvent = false;
    }
  }

  showingAttachement(itemId) {
    this.spinner.show();

    this.service.getDepositVoucher(itemId).subscribe({
      next: (voucherFile) => {
        this.spinner.hide();

        if (voucherFile.file) {
          this.overlayService.showComponent(
            DisplayFileComponent,
            voucherFile.file
          );
        } else {
          window.alert("¡No se encuentra el archivo!");
        }
      },
      error: () => {
        this.spinner.hide();
        showToast(this.toaster, "No pudimos abrir el archivo.", false);
      },
    });
  }

  listTransactions() {
    // const pagination = localStorage.getItem('transactions_pagination');
    // if (pagination != null) {
    //   this.pagination = JSON.parse(pagination);
    // }

    this.store.select(financialTransactions).subscribe((trx: any) => {
      //this.pagination.total = trx.length;
      this.transactions = trx;
      this.getLocalStorage();
      this.filterByCurrency();
      this.getDefaultToggle();
    });
  }

  getDefaultToggle() {
    this.toggle == "pen" ? (this.default = false) : (this.default = true);
  }
  getLocalStorage() {
    this.tabTransactions = localStorage.getItem("tab_transactions");
    if (this.tabTransactions !== null && this.tabTransactions === "1") {
      this.selected = Number(this.tabTransactions);
      //localStorage.removeItem('tab_transactions')
    }

    const toogleLocal = localStorage.getItem("toggle_transaction_currency");
    if (toogleLocal != null) {
      this.currency = toogleLocal;
      this.filterByCurrency();
    }

    toogleLocal === null ? (this.toggle = "pen") : (this.toggle = toogleLocal);
  }

  approved(entity) {
    if (entity.type == "deposit") {
      this.selectedEntity = entity;
      const dialogRef = this.openDialogHelper(
        ApproveDepositDialogComponent,
        { entity: entity, documentNumber: this.documentNumber }
      );
      this.connectDialogListeners(dialogRef, (result) => {
        if (result) {
          this.documentNumber = result.data;
          this.showApproveDialog = true;
          this.overlayService.startConfirmation(
            { ...entity, status: "approved", documentNumber: result.data },
            FinancialTransactionItemComponent,
            "details",
            "edit",
            null,
            FinancialTransactionActions.Saving,
            "/financial-transactions",
            savingSuccessStateById,
            null,
            this.reApplyFilters.bind(this)
          );
        }
        else {
          this.selectedEntity = new Object();
          this.showApproveDialog = false;
          this.documentNumber = "";
        }
      });
    } else {
      this.overlayService.startConfirmation(
        { ...entity, status: "approved" },
        FinancialTransactionItemComponent,
        "details",
        "edit",
        null,
        FinancialTransactionActions.Saving,
        "/financial-transactions",
        savingSuccessStateById,
        null,
        this.reApplyFilters.bind(this)
      );
    }
  }

  openDialogHelper(dialogComp, data?) {
    const dialogRef = this.dialog.open(dialogComp, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      height: "100%",
      position: {
        left: "0",
      },
      autoFocus: false,
      data: data,
    });

    return dialogRef;
  }
  connectDialogListeners(dialogRef, callback) {
    dialogRef.afterClosed().subscribe(callback);
  }

  rejected(entity) {
    let type = entity.type;
    const dialogRef = this.openDialogHelper(MotiveDialogComponent, {
      data: this.rejectionReason,
      type: type,
    });

    this.connectDialogListeners(dialogRef, (result) => {
      if (result?.event == "cancel" || !result) {
        this.selectedEntity = new Object();
        this.showMotiveDialog = false;
        this.rejectionReason = "";
        return;
      }
      this.showMotiveDialog = true;
      this.selectedEntity = entity;
      this.rejectionReason = result?.data;
      this.overlayService.startConfirmation(
        {
          ...entity,
          status: "rejected",
          rejectionReason: this.rejectionReason,
        },
        FinancialTransactionItemComponent,
        "details",
        "edit",
        null,
        FinancialTransactionActions.Saving,
        "/financial-transactions",
        savingSuccessStateById,
        null,
        this.reApplyFilters.bind(this)
      );
    });
  }

  reverted(entity) {
    this.overlayService.startConfirmation(
      { ...entity, status: "in process" },
      FinancialTransactionItemComponent,
      "details",
      "edit",
      "Al continuar el estado volverá a pendiente pero no se le notificará al inversionista.",
      FinancialTransactionActions.Saving,
      "/financial-transactions",
      savingSuccessStateById,
      null,
      this.reApplyFilters.bind(this),
      null,
      "Revertir estado",
      "Volver",
      false,
      false,
      "Recuerda que ya hemos enviado un comunicado sobre el estado aplicado previamente."
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.subscription.unsubscribe();
  }

  paginationHandler(data) {
    this.filtersForm.controls["pagination"].setValue(data.skip);
    this.pagination.skip = data.skip;
    this.pagination.limit = data.limit;
    this.applyFilter(true);
  }

  paginationHandlerClient(data) {
    this.pagination.skip = data.skip;
    //localStorage.setItem('transactions_pagination', JSON.stringify(this.pagination));
    this.listTransactions();
  }

  checkSelectedTypes() { }

  reApplyFilters() {
    this.showMotiveDialog = false;
    this.showApproveDialog = false;
    this.showEditInvestmentDialog = false;

    this.documentNumber = "";
    this.rejectionReason = "";
    this.editedInvestmentData = null;

    this.applyFilter(true);
  }

  applyFilter(paginate = false) {
    this.spinner.show();
    const { createdFrom, createdTo, ...rest } = this.filtersForm.value;
    let filterFormattedValue = rest;

    if (!paginate) {
      this.pagination = Object.assign({}, this.defaultPagination);
      filterFormattedValue["pagination"] = this.pagination.skip;
    }

    if (createdFrom)
      filterFormattedValue = {
        ...filterFormattedValue,
        createdFrom: createDateOnly(createdFrom.toDate().toISOString()),
      };
    if (createdTo)
      filterFormattedValue = {
        ...filterFormattedValue,
        createdTo: createDateOnly(createdTo.toDate().toISOString()),
      };

    let request;
    try {
      request = this.service.get(
        this.pagination.skip,
        this.pagination.limit,
        filterFormattedValue
      );
    } catch (error) {
      this.spinner.hide();
      showToast(
        this.toaster,
        "No pudimos cargar las transacciones. Vuelve a intentarlo.",
        false
      );
      return;
    }

    request
      .subscribe({
        next: (result: any) => {
          this.spinner.hide();

          if (result && result?.financialTransactions?.entities?.length > 0) {
            this.financialTransactioins = result?.financialTransactions?.entities;
            this.pagination.total = result?.financialTransactions?.count;
            filterFormattedValue["pagination"] = this.pagination.skip;

            const keys = Object.keys(filterFormattedValue).filter(
              (key) =>
                filterFormattedValue[key] !== null &&
                filterFormattedValue[key] !== undefined
            );
            const transactionFilter = {};
            keys.map((key) => {
              if (key === "investor") {
                transactionFilter["investor_id"] = filterFormattedValue.investor;
                transactionFilter["investor"] =
                  result.financialTransactions.entities[0]["user"];
                return;
              }
              transactionFilter[key] = filterFormattedValue[key];
            });

            localStorage.setItem(
              "transactions_filter",
              JSON.stringify(transactionFilter)
            );
          } else {
            // A page that went empty walks back one page. Bounded and stepped by the real
            // limit: `skip -= 10` on a skip that is not a multiple of 10 never reaches 0.
            if (this.pagination.skip > 0) {
              this.pagination.skip = Math.max(
                0,
                this.pagination.skip - this.pagination.limit
              );
              this.applyFilter(true);
            }
            this.financialTransactioins = undefined;
          }
        },
        error: () => {
          this.spinner.hide();
          showToast(
            this.toaster,
            "No pudimos cargar las transacciones. Vuelve a intentarlo.",
            false
          );
        },
      });
  }
  resetFiltersToDefaults(reapply = true) {
    this.filtersForm.controls["statuses"].setValue(this.filterDefault.statuses);
    this.filtersForm.controls["types"].setValue(this.filterDefault.types);
    this.filtersForm.controls["createdFrom"].setValue(
      this.filterDefault.createdFrom
    );
    this.filtersForm.controls["createdTo"].setValue(
      this.filterDefault.createdTo
    );
    this.filtersForm.controls["investor"].setValue(this.filterDefault.investor);
    this.filtersForm.controls["currencies"].setValue(
      this.filterDefault.currencies
    );
    this.filtersForm.controls["amount"].setValue(this.filterDefault.amount);
    this.filtersForm.controls["transactionId"].setValue(this.filterDefault.transactionId);

    if (reapply) this.applyFilter();
  }
  resetFilters(reapply = true) {
    this.filtersForm.reset();
    this.selectedInvestor = undefined;

    if (reapply) this.applyFilter();
  }
  filterByUser(event) {
    this.resetFilters(false);

    this.selectedInvestor = event.transactionUser;
    this.filtersForm.controls["investor"].setValue(event.transactionUser._id);

    if (event.transactionType) {
      this.filtersForm.controls["types"].setValue([event.transactionType]);
    }

    this.reApplyFilters();
  }

  exportTransactions() {
    this.service.downloadExcel().subscribe((data: any) => {
      const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = b64toBlob(data.base64, contentType);

      const date = moment().format("DD_MM_YYYY");

      FileSaver.saveAs(blob, `transacciones_${date}`);
    });
  }

  resetPagination() {
    this.pagination.total = 0;
    this.pagination.skip = 0;
    this.pagination.limit = 10;
    //localStorage.removeItem('transactions_pagination');
    this.listTransactions();
    localStorage.removeItem("tab_transactions");
  }

  sendEventPageView(currency: string) {
    this.windowScrollService.sendNewEvent(
      "Financial Transactions",
      `Overview`,
      this.getTabName(),
      currency.toUpperCase()
    );
  }

  getTabName() {
    switch (this.selected) {
      case 0:
        return "Depósitos";
      case 1:
        return "Retiros";
      case 2:
        return "Retenciones";
      case 3:
        return "Inversiones";
      default:
        return "Depósitos";
    }
  }

  editInvestment(entity: any) {
    this.selectedEntity = entity;
    const dialogRef = this.openDialogHelper(
      EditInvestmentDialogComponent,
      { entity: entity, editedData: this.editedInvestmentData }
    );

    this.connectDialogListeners(dialogRef, (result) => {
      if (result) {
        this.editedInvestmentData = result.data;
        this.showEditInvestmentDialog = true;

        const editTransactionData = {
          ...this.editedInvestmentData,
          user: result.data.user._id,
        };

        this.overlayService.startConfirmation(
          editTransactionData,
          FinancialTransactionUpdateItemComponent,
          "details",
          "edit",
          null,
          FinancialTransactionActions.Saving,
          "/financial-transactions",
          savingSuccessStateById,
          null,
          this.reApplyFilters.bind(this)
        );
      } else {
        // User cancelled
        this.selectedEntity = new Object();
        this.showEditInvestmentDialog = false;
        this.editedInvestmentData = null;
      }
    });
  }
}
